import { render, staticRenderFns } from "./EditRentalMonthlyFeeComponent.vue?vue&type=template&id=9b333cfc&"
import script from "./EditRentalMonthlyFeeComponent.vue?vue&type=script&lang=js&"
export * from "./EditRentalMonthlyFeeComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports